import { combineReducers } from 'redux';
import {
  createStatusReducers,
  createMultipleLifeCycleConstants,
  createReducer,
} from 'store/utils/reducerHelpers'
import types from './types'
import { initialElements } from 'helpers/initialState'

const ELEMENTS = createMultipleLifeCycleConstants(types)

const data = createReducer(
  initialElements,
  {
    [ELEMENTS.fetchElements.success]: (
      (state, action) => action.payload
    )
  }
)

const statusReducers = createStatusReducers(types)

export default combineReducers({
  data,
  ...statusReducers,
})



// WEBPACK FOOTER //
// ./src/store/elements/reducer.js